import { render, staticRenderFns } from "./TranslationRequest.vue?vue&type=template&id=9113711a&"
import script from "./TranslationRequest.vue?vue&type=script&lang=js&"
export * from "./TranslationRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports